module.exports = __webpack_public_path__ + "img/x1.1d56ef5d.png";